import { render, staticRenderFns } from "./TwoFactorSetupEmail.vue?vue&type=template&id=7620ccd5&"
import script from "./TwoFactorSetupEmail.vue?vue&type=script&lang=js&"
export * from "./TwoFactorSetupEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports